import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// This redirects to the mock IQC for testing
const ApproverTestScreen = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to mock IQC
    navigate('/approver-review/IQC-2024-TEST-001');
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600 mx-auto mb-4"></div>
        <div className="text-sm text-gray-600">Loading approver screen...</div>
      </div>
    </div>
  );
};

export default ApproverTestScreen;
